
export const URL_API =  'https://quizserver.vityazgroup.ru:8603/api/'
export const URLS = {
    URL_GAMES: `${URL_API}game/`,
    URL_LEVEL: `${URL_API}level/`,
    URL_TASK: `${URL_API}task/`,
    URL_ADDITIONAL_TASK: `${URL_API}additional_task/`,
    URL_LOG_GAME: `${URL_API}log_game/`,
}